module.exports = __webpack_public_path__ + "static/media/facebook-a.f83f21aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/AppFooter/assets/facebook-a.svg
// module id = ./src/common/AppFooter/assets/facebook-a.svg
// module chunks = 14